<template>
    <div class="app">
        <div class="list-item def arr-row record-item" @click="goCharacter()">
            个人健康特征
        </div>
        <div class="list-item def arr-row record-item" @click="goVisit()">
            就诊记录
        </div>
        <div class="list-item def arr-row record-item" @click="goPhysicalExam()">
            体检
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            voucher: {}
        }
    },
    created() {
        this.voucher = this.$store.state.paramModule.param.healthRecord.voucher;
    },
    methods: {
        goVisit() {
            this.$store.commit('updateParam', {
                namespace: 'healthRecord',
                voucher: this.voucher
            });
            this.$router.push('visitRecord');
        },
        goPhysicalExam() {
            this.$store.commit('updateParam', {
                namespace: 'healthRecord',
                voucher: this.voucher
            });
            this.$router.push('physicalExam');
        },
        goCharacter() {
            this.$store.commit('updateParam', {
                namespace: 'healthRecord',
                voucher: this.voucher
            });
            this.$router.push('character');
        },
    }
}
</script>
<style lang="scss">
    .record-item {
        height: 2.5rem;
        line-height: 2.5rem;
        padding-left: 1rem;
    }
</style>


// WEBPACK FOOTER //
// RecordSelect.vue?6cf7feea